import PuttersRecommendationCard from './PuttersRecommendationCard';

export default PuttersRecommendationCard;
